import { render, staticRenderFns } from "./EventWorkshop.vue?vue&type=template&id=3d3f67ca&"
import script from "./EventWorkshop.vue?vue&type=script&lang=js&"
export * from "./EventWorkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports